import { OptionalInformationFormField } from '@exam-center/exam-event-management';
import { Button, Divider, Flex, Form, FormButton, Paper, SectionTitle } from '@shared/components';
import { type Prettify } from '@shared/utils';
import { FormProvider, type UseFormReturn } from 'react-hook-form';

import type { ExamEventCreationFormType } from '../../containers';
import { BasicInformationFormField } from '../basic-information-form-field';
import { ExamCoursesFormField, type ExamCoursesFormFieldProps } from '../exam-courses-form-field';
import {
  ExamScheduleFormField,
  type ExamScheduleFormFieldProps,
} from '../exam-schedule-form-field';
import { LocationFormField, type LocationFormFieldProps } from '../location-form-field';
import { ProctorFormField, type ProctorFormFieldProps } from '../proctor-form-field';

interface ExamEventCreationFormProps {
  form: UseFormReturn<ExamEventCreationFormType>;
  isCreating?: boolean;
  onCancel?: () => void;
  onSubmit: (data: ExamEventCreationFormType) => void;
  slotProps: Prettify<
    ExamScheduleFormFieldProps['slotProps'] &
      LocationFormFieldProps['slotProps'] &
      ProctorFormFieldProps['slotProps'] &
      ExamCoursesFormFieldProps['slotProps']
  >;
}

export default function ExamEventCreationForm(props: Readonly<ExamEventCreationFormProps>) {
  const { form, isCreating = false, onCancel, onSubmit, slotProps } = props;

  const { isSubmitting } = form.formState;

  return (
    <FormProvider {...form}>
      <Form onSubmit={form.handleSubmit(onSubmit)}>
        <Paper
          sx={(theme) => ({
            flex: 1,
            p: theme.spacing(6),
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(6),
            borderRadius: theme.shape.rounded(2),
          })}
        >
          <SectionTitle title='Basic Information' />
          <BasicInformationFormField />
          <Divider />
          <SectionTitle title='Exam Course' />
          <ExamCoursesFormField slotProps={slotProps} />
          <Divider />
          <SectionTitle title='Exam Schedule' />
          <ExamScheduleFormField slotProps={slotProps} />
          <Divider />
          <SectionTitle title='Exam Location' />
          <LocationFormField slotProps={slotProps} />
          <Divider />
          <SectionTitle title='Proctor' />
          <ProctorFormField slotProps={slotProps} />
          <Divider />
          <SectionTitle title='Optional Information' />
          <OptionalInformationFormField />
        </Paper>
        <Flex
          sx={(theme) => ({
            justifyContent: 'flex-end',
            gap: theme.spacing(3),
            pt: theme.spacing(6),
          })}
        >
          <Button
            color='secondary'
            variant='outlined'
            size='large'
            onClick={onCancel}
            disabled={isSubmitting || isCreating}
          >
            ยกเลิก
          </Button>
          <FormButton size='large' label='สร้างรอบสอบ' loading={isCreating} />
        </Flex>
      </Form>
    </FormProvider>
  );
}
